/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Billing_Alltime_ContractInputs */



/**
* | output |
* | --- |
* | "{count} covered by contract" |
*
* @param {Admin_Billing_Alltime_ContractInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_billing_alltime_contract = /** @type {((inputs: Admin_Billing_Alltime_ContractInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Alltime_ContractInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} durch Vertrag abgedeckt`)
	return /** @type {LocalizedString} */ (`${i?.count} covered by contract`)
});